import { joinUrl } from '@root/src/lib/joinUrl';
function checkForErrors(response) {
    if (!response.ok) {
        throw Error(response.statusText ||
            `getIdApiUserData | An api call returned HTTP status ${response.status}`);
    }
    return response;
}
const callApi = (url) => {
    return fetch(url, {
        credentials: 'include',
    })
        .then(checkForErrors)
        .then((response) => response.json());
};
const cache = {};
export const getIdApiUserData = (ajaxUrl) => {
    if (!cache.idapiUserMeResponse) {
        const url = joinUrl([ajaxUrl, 'user/me']);
        cache.idapiUserMeResponse = callApi(url);
    }
    return cache.idapiUserMeResponse;
};
export const getIdapiUserIdentifiers = (ajaxUrl) => {
    if (!cache.idapiUserIdentifiersResponse) {
        const url = joinUrl([ajaxUrl, 'user/me/identifiers']);
        cache.idapiUserIdentifiersResponse = callApi(url);
    }
    return cache.idapiUserIdentifiersResponse;
};
